import { useEffect, useState } from "react";
import { getAptData, getAptPosts } from "../api/apts";

export const useAptData = (target) => {
  const [aptData, setAptData] = useState(null);
  const [posts, setPosts] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!target) return;

    setIsLoading(true);
    setError(null);

    Promise.all([getAptData(target), getAptPosts(target)])
      .then(([dataRes, postsRes]) => {
        setAptData(dataRes.data.apt_data);
        setPosts(postsRes.data.posts ?? []);
      })
      .catch((err) => {
        console.error(err);
        setError(err);
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, [target]);

  return { aptData, posts, isLoading, error };
};
